import clsx from "clsx";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdCheck, MdClose } from "react-icons/md";
import { EButtonKind } from "src/components/Button/Button.types";
import ColorPicker from "src/components/ColorPicker/ColorPicker";
import Modal from "src/components/Modal/Modal";
import ModalHasUnsavedChanges from "src/components/Modal/ModalHasUnsavedChanges";
import { ICON_SIZES } from "src/constants/icons";
import { ASK_CONFIRMATION_ON_SAVE_OR_UPDATE } from "src/helpers/constants";
import { objectHasChanges } from "src/helpers/utils";
import useColors from "src/hooks/useColors";
import useModalsStore from "src/store/modalsStore";

const MonthColorsModal: React.FC = () => {
  const { t } = useTranslation();
  const { allMonthsColors } = useColors();
  const { setShowMonthColorsModal } = useModalsStore();
  const [monthColors, setMonthColors] = useState<any>(allMonthsColors);

  const closeModal = () => {
    setShowMonthColorsModal(false);
  };

  const hasChanges = useMemo(() => {
    return objectHasChanges({
      original: allMonthsColors,
      edited: monthColors,
    });
  }, [allMonthsColors, monthColors]);

  return (
    <Modal
      onEscape={() => closeModal()}
      className={clsx(["md:!max-w-[480px]", "md:!min-w-[280px]", "md:w-full"])}
    >
      <Modal.Header
        onClose={() => closeModal()}
        title="Personalizar colores por mes"
      />
      <Modal.Body>
        <div
          className={clsx(["flex", "w-full", "flex-col", "gap-4", "md:gap-6"])}
        >
          <div className={clsx(["flex", "flex-col", "gap-2"])}>
            <div
              className={clsx([
                "grid",
                "grid-cols-3",
                "gap-2",
                "flex",
                "items-center",
                "md:text-sm",
                "text-xs",
              ])}
            >
              <div></div>
              <div>{t("pages:appearance.bg_color")}</div>
              <div>{t("pages:appearance.text_color")}</div>
            </div>
            {[
              t("dates:months.january"),
              t("dates:months.february"),
              t("dates:months.march"),
              t("dates:months.april"),
              t("dates:months.may"),
              t("dates:months.june"),
              t("dates:months.july"),
              t("dates:months.august"),
              t("dates:months.september"),
              t("dates:months.october"),
              t("dates:months.november"),
              t("dates:months.december"),
            ].map((month, index: number) => {
              return (
                <div
                  className={clsx(["grid", "grid-cols-3", "gap-2"])}
                  key={month}
                >
                  <div
                    className={clsx([
                      "flex",
                      "items-center",
                      "text-xs",
                      "md:text-sm",
                    ])}
                  >
                    {month}
                  </div>
                  <ColorPicker
                    showText={false}
                    onChange={(color: any) => {
                      setMonthColors({
                        ...monthColors,
                        [index + 1]: {
                          ...monthColors[index + 1],
                          bg: color.rgb,
                        },
                      });
                    }}
                    textColor={monthColors[index + 1].color}
                    color={monthColors[index + 1].bg}
                  />
                  <ColorPicker
                    showText={false}
                    onChange={(color: any) => {
                      setMonthColors({
                        ...monthColors,
                        [index + 1]: {
                          ...monthColors[index + 1],
                          color: color.rgb,
                        },
                      });
                    }}
                    textColor={monthColors[index + 1].bg}
                    color={monthColors[index + 1].color}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        leftContent={hasChanges ? <ModalHasUnsavedChanges /> : null}
        actions={[
          {
            text: t("common:buttons.update"),
            onClick: () => {
              if (ASK_CONFIRMATION_ON_SAVE_OR_UPDATE) {
                // setShowUpdateDialog(true);
              } else {
                // updateAccount();
              }
            },
            icon: <MdCheck size={ICON_SIZES.SM} />,
            kind: EButtonKind.EDIT,
            isLoading: false,
            disabled: !hasChanges,
          },
          {
            text: t("common:buttons.close"),
            onClick: () => closeModal(),
            kind: EButtonKind.NORMAL,
            icon: <MdClose size={ICON_SIZES.SM} />,
            disabled: false,
          },
        ]}
      />
    </Modal>
  );
};

export default MonthColorsModal;
